import React, { useState } from 'react';
import { Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { cn } from '../../lib/utils';
import './date-picker.css';

const DatePicker = ({ 
  value, 
  onChange, 
  className = '', 
  disabled = false, 
  required = false, 
  placeholder = "Select date",
  minDate,
  maxDate 
}) => {
  // Convert Date object to string format for input[type="date"]
  const dateValue = value instanceof Date ? value.toISOString().split('T')[0] : value || '';

  const handleDateChange = (e) => {
    const dateString = e.target.value;
    if (dateString) {
      // Convert string back to Date object
      const date = new Date(dateString);
      onChange(date);
    } else {
      onChange(null);
    }
  };

  const minDateString = minDate instanceof Date ? minDate.toISOString().split('T')[0] : minDate;
  const maxDateString = maxDate instanceof Date ? maxDate.toISOString().split('T')[0] : maxDate;

  return (
    <div className={cn("relative", className)}>
      <div className="relative">
        <input
          type="date"
          value={dateValue}
          onChange={handleDateChange}
          disabled={disabled}
          required={required}
          min={minDateString}
          max={maxDateString}
          className={cn(
            "date-picker-input flex h-9 w-full rounded-md border border-gray-200 bg-white pl-3 pr-3 py-2 text-sm ring-offset-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            "cursor-pointer text-left text-gray-900",
            !dateValue && "text-gray-500"
          )}
        />
      </div>
    </div>
  );
};

export default DatePicker;
